export const checkPassword = (password, returnMessage) => {
  if (!password) {
    return returnMessage ? ['Passwort ist erforderlich!'] : false;
  }

  const lengthCheck = password.length > 7;

  const numbers = /[0-9]/;
  const letters = /[a-zA-Z]/;
  const specialChars = /[_!@#$%^&*(),.?":{}|<>$=´`+-/°€\\]/;

  const numberCheck = password.match(numbers);
  const letterCheck = password.match(letters);
  const specialCharCheck = password.match(specialChars);

  if (returnMessage) {
    const message = [];
    if (!lengthCheck) {
      message.push('Das Passwort muss mindestens 8 Zeichen lang sein!');
    }
    if (!numberCheck) {
      message.push('Das Passwort muss mindestens eine Zahl beinhalten!');
    }
    if (!letterCheck) {
      message.push('Das Passwort muss mindestens einen Buchstaben beinhalten!');
    }
    if (!specialCharCheck) {
      message.push('Das Passwort muss mindestens ein Sonderzeichen beinhalten!');
    }
    return message;
  }

  return lengthCheck && numberCheck && letterCheck && specialCharCheck;
};

export default checkPassword;
